<template>
  <a
    class="colorBlack navLink u-full-width"
    :href="item.target_url"
  >
    <div class="dropdownLeadImageContainer">
      <img v-lazy="item.image">
    </div>
    <div>
      <div v-html="item.title" />
      <BiddingStatus
        :item_id="item_id"
        :view_type="'condensed_list'"
      />
    </div>
  </a>
</template>

<script>
import BiddingStatus from '@/components/BiddingStatus'

export default {
	name: 'ItemCard',
	components: {
		BiddingStatus
	},
	props: [
		'item_id'
	],
	data () {
		return {
		}
	},
	computed: {

		// this was formerly in mapState - can't use that due to Edge
		items: function() {
			return this.$store.state.items
		},

		// customer was formerly in mapState - can't use that due to Edge
		biddingStatuses: function() {
			return this.$store.state.customer
		},

		// this was formerly in mapState - can't use that due to Edge
		lists: function() {
			return this.$store.state.lists
		},

		item: function () {
			if (typeof (this.items['ITEMID_' + this.item_id]) !== 'undefined') {
				return this.items['ITEMID_' + this.item_id]['card']
			}else{
				return {
					target_url: '',
					image: '',
					title: ''
				}
			}
		}
	},
	methods: {
	}
}

</script>

<style scoped>

</style>
